import { render, staticRenderFns } from "./switch-base-plan-dialog.vue?vue&type=template&id=d9dbad9e&scoped=true"
import script from "./switch-base-plan-dialog.vue?vue&type=script&lang=js"
export * from "./switch-base-plan-dialog.vue?vue&type=script&lang=js"
import style0 from "./switch-base-plan-dialog.vue?vue&type=style&index=0&id=d9dbad9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dbad9e",
  null
  
)

export default component.exports